module.exports = __webpack_public_path__ + "img/gas-valve.d405c63e.png";